import React, { useEffect, useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import server from '../../../api/server.js';
import StatusPanel from './StatusPanel.jsx';
import { BsHourglass } from "react-icons/bs";

const TaskStatusComponent = ({serviceID, clientID}) => {
    const [client_id, setClient_id] = useState(null);
    const [service_id, setService_id] = useState(null);
    const [email, setEmail] = useState(null);
    const [runningCount, setRunningCount] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const intervalRef = useRef(null);
    const isFetchingRef = useRef(false);
    function getCookie(name) {
        function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
        var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
        return match ? match[1] : null;
    }
    useEffect(()=> {
        if(clientID){
            setClient_id(clientID)
        }
        if(serviceID){
            setService_id(serviceID)
        }
        const user = getCookie('dashboard_login_user_creds') ? JSON.parse(getCookie('dashboard_login_user_creds')) : null;
        if (user) {
            setEmail(user.email);
        }
    }, [clientID, serviceID])

    useEffect(() => {
        // Clear any existing interval
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
    
        // Only set up interval if we have all required data
        if (client_id && service_id && email) {
          
          // Initial call
          getTaskStatus();
          
          // Set up interval
          intervalRef.current = setInterval(() => {
            getTaskStatus();
          }, 30000);
        }
        // Cleanup function
    return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
        isFetchingRef.current = false;
      };
    }, [client_id, service_id, email])
    const getTaskStatus = async () => {
        try {
            if (isFetchingRef.current) return;
            isFetchingRef.current = true;
            let res = await server.getTaskStatusList(client_id,service_id, email, 'home', undefined, 'Last 7 Days')
            if (res.status === 200){
                let resp = await res.json()
                let count = resp.data.filter(item => item.overall_status === 'processing' || item.overall_status === 'queued').length
                setRunningCount(count)
            }
        } catch (error) {
        } finally {
            isFetchingRef.current = false;
        }
    }
    const toggleTaskStatusPanel = () => {
        setIsOpen(!isOpen);
      };
  return (
        <div className='relative'>
            <button 
                onClick={toggleTaskStatusPanel}
                className="relative p-2 text-gray-600 hover:text-gray-800 focus:outline-none"
            >
                <BsHourglass className="h-6 w-6" />
                {runningCount > 0 && (
                <span className="absolute top-1 right-1 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-xs text-white">
                    {runningCount}
                </span>
                )}
            </button>
            {
                isOpen && createPortal(
                    <div 
                        className="fixed inset-y-0 right-0 bg-white shadow-lg flex flex-col transition-transform duration-300 ease-in-out transform translate-x-0"
                        style={{ width: "30rem", zIndex: 2147483647 }}
                    >
                        <StatusPanel isOpen={isOpen} setIsOpen={setIsOpen} clientID={client_id} serviceID={service_id}/>
                    </div>,
                    document.body
                )
            }
        </div>
    );
};

export default TaskStatusComponent;
